export const map = () => import('../components/sw-widget-geo-map.vue');
export const errorComponent = () =>
  import('@/shared/widget-library/sw-widget-error-component.vue');
export const donutChart = () =>
  import('../components/sw-widget-donut-chart.vue');
export const verticalStatus = () =>
  import('../components/sw-widget-vertical-status.vue');
export const horizontalBarChart = () =>
  import('../components/sw-widget-horizontal-bar-chart.vue');
export const horizontalStatus = () =>
  import('../components/sw-widget-horizontal-status.vue');

export const componentMapping: any = {
  map,
  donutChart,
  errorComponent,
  verticalStatus,
  horizontalBarChart,
  horizontalStatus,
};
